export default __webpack_public_path__ + "static/media/vol1_5.d2596ac5.png";